import React, { useState } from 'react';
import style from './TradePlanViewsContainer.module.css';
import ActiveTradePlanModule from '../activeTradePlanModule/ActiveTradePlanModule';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { TradePlanGlobalControls } from './tradePlanGlobalControls/TradePlanGlobalControls';
import { useTradePlanSelectionHotkeys } from '../../../../commands/useTradePlanSelectionHotkeys';
const sortMap = {
  bySymbol: 'tradePlanIdsSortedBySymbol',
  byStatus: 'tradePlanIdsSortedByStatus',
  byTemplate: 'tradePlanIdsSortedByTemplate',
  byCreationTime: 'tradePlanIdsSortedByCreateTime',
};

const TradePlanViewsContainer = observer(() => {
  const { tradePlanStore } = useWebsocketStore();
  const [sortingKeyword, setSortingKeyword] = useState('bySymbol');
  const getter = sortMap[sortingKeyword];
  useTradePlanSelectionHotkeys(tradePlanStore[getter]);
  return (
    <div className={style.outerContainer}>
      <TradePlanGlobalControls
        sortingKeyword={sortingKeyword}
        setSortingKeyword={setSortingKeyword}
      />
      <div
        className={style.container}
      >
        {tradePlanStore[getter].map((id) => (
          <ActiveTradePlanModule key={id} tradePlanId={id} />
        ))}
      </div>
    </div>
  );
});

TradePlanViewsContainer.propTypes = {
  tradePlanIds: PropTypes.array,
};
export default TradePlanViewsContainer;
